// Copyright (c) StrangeBee 2023

import { QuerySelector } from 'thehive-sdk';

export const computeListSelector = (): QuerySelector => ({
    head: [{ name: 'listTask' }, { name: 'inCase' }],
    extraData: ['actionRequired', 'shareCount', 'case'],
    name: `get-global-tasks`,
    sort: ['-flag', '-startDate'],
});
